module.exports = "<!-- <app-privatenav></app-privatenav> -->\n<app-overview></app-overview>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/private/private.component.html
// module id = ../../../../../src/app/private/private.component.html
// module chunks = main